
import { useState } from 'react';
import { apiFetch } from '../../utils/api';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';
import ResourceCategories from '../../constants/resourceCategories';
import '../../styles/admin/AddResources.css';

export default function AddResources() {
  const [form, setForm] = useState({
    title: '',
    link: '',
    description: '',
    category: '',
  });
  const [message, setMessage] = useState('');

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
      const data = await apiFetch('/api/resources', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
      if (data.ok) {
      setMessage('Resource added!');
      setForm({ title: '', link: '', description: '', category: '' });
    } else {
      setMessage('Error adding resource');
    }
  };

  return (
    <ProtectedAdminRoute>
      <div className="add-project-flex">
      <div className="add-project-form">
        <h2>Add Resource</h2>
        <form onSubmit={handleSubmit} autoComplete="off">
          <input
            name="title"
            placeholder="Resource Title"
            value={form.title}
            onChange={handleChange}
            required
            autoComplete="off"
            className="add-resource-input"
          />
          <input
            name="link"
            placeholder="Resource URL or Path (e.g. /resource or https://...)"
            value={form.link}
            onChange={handleChange}
            required
            autoComplete="off"
            className="add-resource-input"
          />
          <textarea
            name="description"
            placeholder="Resource description"
            value={form.description}
            onChange={handleChange}
            rows={3}
            className="add-resource-textarea"
            autoComplete="off"
          />
          <select
            name="category"
            value={form.category}
            onChange={handleChange}
            required
            className="add-resource-select"
          >
            <option value="" disabled>
              Select Category
            </option>
            {ResourceCategories.OPTIONS.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
          <button 
            type="submit"
            className="add-resource-submit-btn"
          >
            Add Resource
          </button>
        </form>
        {message && (
          <div className={`message ${message.includes('Error') ? 'error' : 'success'}`}>{message}</div>
        )}
      </div>
    </div>
    </ProtectedAdminRoute>
  );
}